import React from 'react';

/**
 * Regras da senha: as mesmas do servidor (`validate_password_strength` em
 * backend/services/auth_service.py). Se o servidor mudar, mude aqui também.
 */
export const REQUISITOS_SENHA = [
  { rotulo: 'Mínimo 8 caracteres', regra: /.{8,}/ },
  { rotulo: 'Letra maiúscula', regra: /[A-Z]/ },
  { rotulo: 'Letra minúscula', regra: /[a-z]/ },
  { rotulo: 'Número', regra: /[0-9]/ },
  { rotulo: 'Caractere especial', regra: /[!@#$%^&*(),.?":{}|<>\-_=+[\]/\\]/ },
];

export function senhaAtende(senha) {
  return REQUISITOS_SENHA.every((r) => r.regra.test(senha));
}

/** Barra de força e lista do que falta, como na prancheta de recuperação de senha. */
export default function RequisitosSenha({ senha }) {
  const cumpridos = REQUISITOS_SENHA.filter((r) => r.regra.test(senha)).length;
  const tom = cumpridos <= 2 ? 'perigo' : cumpridos <= 4 ? 'atencao' : 'sucesso';

  return (
    <div className="entrada__requisitos">
      <div className="entrada__forca" aria-hidden="true">
        {REQUISITOS_SENHA.map((r, i) => (
          <span key={r.rotulo} className={`entrada__forca-passo${i < cumpridos ? ` entrada__forca-passo--${tom}` : ''}`} />
        ))}
      </div>
      <ul className="entrada__lista-requisitos" aria-label="Requisitos da senha">
        {REQUISITOS_SENHA.map((r) => {
          const ok = r.regra.test(senha);
          return (
            <li key={r.rotulo} className={ok ? 'entrada__requisito entrada__requisito--ok' : 'entrada__requisito'}>
              <span className="sj-icone sj-icone--sm" aria-hidden="true">{ok ? 'check_circle' : 'radio_button_unchecked'}</span>
              {r.rotulo}
              <span className="sj-oculto">{ok ? ', cumprido' : ', falta'}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
